import { PopUpComponent } from 'cd-eft/components/EFH2/Waterway Sizing Calulator/PopUpForm/PopUpForm';
import { formatDate, getMonthDayYear } from 'cd-eft/utils/formatDate';
import React, { Fragment, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import './printPDF.scss';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { toTitleCase } from '../../../utils/stringUtilities';


interface IPrintComponentProps {
    functionProp: any;
    printButtonText: string;
    componentToPrint: any;
    componentProps: any;
    printButtonClasses?: string;
    callFrom?: string;
}
/**
 * Common component to print a supplied component through the browsers print menu.
 * @param {IPrintComponentProps} props 
 * @param props.functionProp
 * @param {string} props.printButtonText - String to be inside the button, styled already as usa-button.
 * @param {string} props.printButtonClasses - Optional param to add additional class names to the button.
 * @param props.componentToPrint - The component to be printed.
 * @param {object} [props.componentProps] - The props of the componentToPrint 
 * @returns 
 */
export const PrintComponent = (props: IPrintComponentProps) => {
    const buttonClasses = props.printButtonClasses ? props.printButtonClasses : '';
    const componentRef = useRef(null);


    //Dynamic data that will pass to the pdf
    const [formData, setFormData] = useState({
        name: '',
        // designedByName: String(localStorage['username']).split('@')[0].replace('.', ' ').split(' ').map(word => (word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())).join(' '),
        designedByName: toTitleCase(String(localStorage['username']).split('@')[0].replace('.', ' ')),
        designedByDate: String(getMonthDayYear()),
        practice: '',
        location: '',
        description: '',
        checkedByName: '',
        approvedByName: '',
        checkedByDate: '',
        approvedByDate: ''
    });

    const handleFormChange = (updatedData) => {
        setFormData(updatedData);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleConfirmPrint = () => {
        handlePrint();
        if (props.functionProp && props.functionProp.saveButtonPopup) {
            props.functionProp.saveButtonPopup = false;
        }
    };

    const handleCancelPrint = () => {
        if (props.functionProp && props.functionProp.saveButtonPopup) {
            props.functionProp.saveButtonPopup = false;
        }
    };

    return (

        <div className="print-button">

            <div className="dialog">
                <PopUpComponent formData={formData} onFormChange={handleFormChange} callFrom={props.callFrom} />
                <button className="usa-button px-5 mr-0" style={{ float: 'right' }} onClick={handleConfirmPrint}>Submit</button>
                <button className="usa-button usa-button--outline" style={{ float: 'right' }} onClick={handleCancelPrint}>Close</button>
            </div>
            <div className='ref-container' hidden={true}>
                <RefWrapperComponent ref={componentRef} formData={formData} componentProps={props.componentProps} componentToPrint={props.componentToPrint} />
            </div>
        </div>

    )
}

interface IWrapperProps {
    componentToPrint: any;
    componentProps: any;
    formData: any;
}
/**
 * Wrapper for the component to be printed that adds the containing ref atrribute to the div
 */
const RefWrapperComponent = React.forwardRef((props: IWrapperProps, ref) => {

    return (
        <div ref={ref as React.MutableRefObject<null>}>
            <props.componentToPrint {...props.componentProps} formData={props.formData} />
        </div>
    )
})